import React from 'react';
import { HeroBannerStyles as S } from './HeroBanner.styles';
import { AnimatePresence } from 'framer-motion';
import VideoWithControls from '@stories/Components/Misc/VideoWithControls/VideoWithControls';
import { withMotionMax } from '@hoc/withMotionMax';
import { MotionWrapper, rootMargin } from '@helpers/motionWrapper';
import { useInView } from '@netc/hooks';
const HeroBanner = (props) => {
    const [wordIndex, setWordIndex] = React.useState(0);
    const hasAnimatedRef = React.useRef(false);
    const [title, words] = React.useMemo(() => {
        const regex = /(\[.*?\])/g;
        const match = props.title.match(regex);
        const firstSquareBracket = props.title.indexOf('[');
        if (firstSquareBracket > -1 && match?.[0]) {
            return [
                props.title.substring(0, firstSquareBracket),
                match[0].replace('[', '').replace(']', '').split('/'),
            ];
        }
        return [props.title, []];
    }, [props.title]);
    React.useEffect(() => {
        // Only set up interval if there are words to cycle through
        if (words.length <= 1)
            return;
        const intervalId = setInterval(() => {
            hasAnimatedRef.current = true;
            setWordIndex((prevIndex) => (prevIndex + 1) % words.length);
        }, 3000); // Cycle every 3 seconds
        // Clean up both timeout and interval on unmount
        return () => {
            if (intervalId)
                clearInterval(intervalId);
        };
    }, [words.length]);
    const [elementRef, inView] = useInView({ rootMargin });
    return (React.createElement(MotionWrapper, { inView: inView },
        React.createElement(S.Container, { id: props.anchorId },
            React.createElement(S.TopBar, { ref: elementRef },
                React.createElement(S.Title, null,
                    React.createElement("span", { "data-title": true },
                        title,
                        ' ',
                        words.length > 0 && (React.createElement(S.SwappingWords, null,
                            React.createElement(AnimatePresence, null,
                                React.createElement(S.Word, { "data-has-animated": hasAnimatedRef.current, key: `HeroBanner_Word_${words[wordIndex]?.replace(/ /g, '-')}` }, words[wordIndex])))))),
                React.createElement(S.Intro, { dangerouslySetInnerHTML: { __html: props.introText } })),
            React.createElement(S.VideoWrapper, null,
                React.createElement(VideoWithControls, { video: props.video, enableVolumeControl: true, eagerPoster: true })))));
};
export default withMotionMax(HeroBanner);
